<template>
  <LoadingContainer v-if="isLoading && !Object.keys(user.settings).length" class="box--msini"/>

  <form v-else @submit.prevent="submitUpdateUserAccount">
    <section>
      <SectionTitle class="mt-3">
        <h5>Conta</h5>
      </SectionTitle>
      <UserForm :user="user"/>
    </section>

    <section>
      <SectionTitle class="mt-3">
        <h5>Configurações de privacidade</h5>
      </SectionTitle>
      <UserSettingsForm :settings="user.settings"/>
    </section>

    <div class="d-flex align-items-center">
      <SecondaryButton type="submit" :disabled="isLoading || $v.user.$invalid">
        Atualizar dados
      </SecondaryButton>
      <b v-if="hasSuccess == 'ACCOUNT'" class="ml-4 text-success">
        ✔ Dados salvos
      </b>
    </div>
  </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SecondaryButton from '@/components/buttons/SecondaryButton'
  import userUpdateAccountRules from '@/validations/user/userUpdateAccountRules'
  import UserSettingsForm from './UserSettingsForm'
  import UserForm from './UserForm'
  import LoadingContainer from '@/components/layout/LoadingContainer'
  import SectionTitle from '@/components/text/titles/SectionTitle'
  import { getUserSettings } from '@/api/user.api'

  export default {
    components: {
      SecondaryButton,
      UserSettingsForm,
      UserForm,
      LoadingContainer,
      SectionTitle,
    },

    validations: {
      user: userUpdateAccountRules
    },

    async mounted () {
      this.isLoading = true

      this.user.settings = await getUserSettings()

      this.isLoading = false
    },

    data: () => ({
      isLoading: true,

      hasSuccess: false,

      hasError: false,

      user: {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        bio: '',
        settings: {}
      },
    }),

    computed: {
      ...mapGetters('user', {
        userComputed: 'user',
      }),
    },

    watch: {
      userComputed: {
        immediate: true,
        handler (user) {
          this.user = Object.assign(this.user, {
            name: user.name,
            email: user.email,
            bio: user.bio.replace(/<br\s*\/?>/gi,"\n").trim()
          })
        }
      },

      hasSuccess (newState) {
        if (newState) {
          setTimeout(() => this.hasSuccess = false, 4000)
        }
      },
    },

    methods: {
      ...mapActions('user', ['updateUser']),

      async submitUpdateUserAccount () {
        this.isLoading = true

        const response = await this.updateUser(this.user)
        
        if (!response.success) {
          this.hasError = response.errors.join(', ')
        } else {
          this.hasError = false
          this.hasSuccess = 'ACCOUNT'
        }

        this.isLoading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  h2 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  section {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(#000, .1);
  }
</style>